import camelCase from 'camelcase'
import React, { useMemo } from 'react'

import image from '@lib/image'

import '@components/CompactTripCard/Header/styles.scss'

interface CarrierLogo {
  source: string
}

interface HeaderProps {
  connection: Connection
  segment?: Segment
  carrierLogo: CarrierLogo
  showName?: boolean
  showLinePrefix?: boolean
}

const Header = ({ connection, carrierLogo, showName, showLinePrefix, segment }: HeaderProps) => {
  const key = camelCase(carrierLogo.source)
  const { line, linePrefix } = segment || {}

  const uniqueCarrierCodes = [
    ...new Set(connection.segments.map(item => (item[key as keyof Segment] as Carrier)?.code)),
  ]

  const carrierFromConnection = useMemo(
    () => connection.segments.find(item => item[key as keyof Segment])?.[key as keyof Segment] as Carrier,
    [connection.segments, key],
  )

  const carrierFromSegment = segment?.[key as keyof Segment] as Carrier
  const carrier = showName ? carrierFromSegment : carrierFromConnection

  return (
    <div className="header-container">
      <div className="left-container">
        <img src={image.getMarketingCarrierLogo(carrier?.code)} className="carrier-logo" alt="" />
        {uniqueCarrierCodes.length > 1 && !showName && (
          <span className="operating-carrier-logos-count">{`+${uniqueCarrierCodes.length - 1}`}</span>
        )}
        {showName && <span className="operating-carrier-name">{carrier?.tradeName}</span>}
      </div>
      {showLinePrefix && (
        <div className="right-container">
          <span className="line">{linePrefix}</span>
          <span className="line">{line}</span>
        </div>
      )}
    </div>
  )
}

export default Header
